import axios from "@/axios"

const url = "/api/encaste/task-calendar"

class TaskCalendarService {
	async getTasks(params) {
		try {
			const { data } = await axios.get(`${url}/get-tasks`, {
				params,
			})
			return data
		} catch (err) {
			console.error(err)
		}
	}
	async getTaskDetail(id) {
		try {
			const { data } = await axios.get(`${url}/get-task-detail/${id}`)
			return data
		} catch (err) {
			console.error(err)
		}
	}
	async executeTask(id, params) {
		try {
			const { data } = await axios.put(`${url}/execute-task/${id}`, params)
			return data
		} catch (err) {
			console.error(err)
		}
	}
	async getPendingTaskCounter(params) {
		try {
			const { data } = await axios.get(`${url}/pending-task-counter`)
			return data
		} catch (err) {
			console.error(err)
		}
	}
	async executeTaskPartially(params) {
		try {
			const { data } = await axios.put(`${url}/execute-tasks-partially`, params)
			return data
		} catch (err) {
			console.error(err)
		}
	}
	async getTasksBySpecimenId(specimenId) {
		try {
			const { data } = await axios.get(`${url}/get-task-by-specimen/${specimenId}`)
			return data
		} catch (err) {
			console.error(err)
		}
	}
	async getPendingTaskCounterByLoteId(loteId) {
		try {
			const { data } = await axios.get(`${url}/pending-task-counter-by-lote-id/${loteId}`)
			return data
		} catch (err) {
			console.error(err)
		}
	}
}
export default new TaskCalendarService()
